const createStepHandler = ({ goToStep }, { index, stepComplete }) => () =>
  stepComplete && goToStep && goToStep(index);

export default createStepHandler;
